// ถ้าหน้าไหนพัง ให้ขึ้นข้อความพร้อมปุ่มลองใหม่ แทนที่จะเงียบ/หน้าขาว
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('หน้าจอขัดข้อง', error, info.componentStack);
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    // เปลี่ยนหน้า → ล้างสถานะพัง
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto mt-10 flex max-w-lg flex-col items-center gap-4 rounded-3xl border-2 border-st-rose/40 bg-white p-8 text-center">
        <div className="text-5xl">😵</div>
        <h2 className="text-2xl font-bold">หน้านี้ขัดข้อง</h2>
        <p className="text-lg text-muted">ข้อมูลยังอยู่ครบ ลองกดโหลดใหม่ ถ้ายังเป็นอยู่ แจ้งผู้ดูแลระบบพร้อมบอกว่ากดอะไรก่อนหน้านี้</p>
        <p className="break-all rounded-xl bg-paper px-3 py-2 font-mono text-sm text-muted">{this.state.error.message}</p>
        <div className="flex gap-2">
          <button type="button" onClick={() => this.setState({ error: null })} className="min-h-12 rounded-xl border-2 border-line px-5 font-display text-lg font-semibold">
            ลองอีกครั้ง
          </button>
          <button type="button" onClick={() => window.location.reload()} className="min-h-12 rounded-xl bg-brand px-5 font-display text-lg font-semibold text-white">
            โหลดหน้าใหม่
          </button>
        </div>
      </div>
    );
  }
}
